class RangeSliderMortgage {
    constructor(el, opts) {
        if (!el) {
            console.error('RangeSliderFilter constructor can\'t find given "el" in DOM!');
            return;
        }

        let inputs                 = el.querySelectorAll('input');
        let type                   = el.dataset.sliderType;
        let inpMin                 = inputs[0];
        let currentMinVal          = parseInt(inpMin.value.replace(/\ /g,''));
        let inlineElOpts           = JSON.parse(el.dataset.sliderRange);
        let minVal                 = inlineElOpts.min;
        let maxVal                 = inlineElOpts.max;
        let step                   = inlineElOpts.step;

        let options = {
            start: [currentMinVal],
            step: step,
            connect: [true, false],
            range: {
                'min': minVal,
                'max': maxVal
            },
            // format: wNumb({
            //     decimals: 0,
            //     thousand: ' '
            // })
        };

        noUiSlider.create(el, options);

        this.type = type;
        this.sliderRange = el.noUiSlider;

        el.noUiSlider.on('slide', function(values, handle) {
            // console.log('slide')
            let value = Math.round(values[handle]);
            let valueToRender = value.toLocaleString('ru-RU');
            let currentSlider = this.target;
            let renderValue = $(currentSlider).find('[data-value-render]');
            let sliderInp = $(this.target).find('input');
            window.requestAnimationFrame(() => {
                if ( type === 'price' || type === 'firstPayment') {
                    renderValue.html( valueToRender + ' ₽' );
                } else if ( type === 'years') {
                    renderValue.html(valueToRender + ' ' + declOfNum(value, ['год', 'года', 'лет']) );
                } else if ( type === 'month') {
                    renderValue.html(valueToRender + ' мес.');
                }
            });
            inpMin.value = value;
            $(inpMin).trigger('change');
            // убираем фокус с инпута при движении ползунка на мобилке
            sliderInp.blur();
        });

        $('.RangeSliderSingle_inputs').on('click', function () {
            let $inp = $(this).find('input');
            let renderInput = $(this).find('[data-value-render]');
            renderInput.hide();
            $inp
                .show()
                .trigger('focus');
        });

        inputs.forEach(function (input, handle) {
            let value = Math.round(input.value);
            let valueToRender = value.toLocaleString('ru-RU');
            let currentSlider = input.parentElement;
            let renderValue = $(currentSlider).find('[data-value-render]');
            window.requestAnimationFrame(() => {
                if ( type === 'price' || type === 'firstPayment') {
                    renderValue.html( valueToRender + ' ₽' );
                } else if ( type === 'years') {
                    renderValue.html(valueToRender + ' ' + declOfNum(value, ['год', 'года', 'лет']) );
                } else if ( type === 'month') {
                    renderValue.html(valueToRender + ' мес.');
                }
            });

            input.addEventListener('focus', function () {
                let $inp = $(this);
                let renderInput = $inp.parent().find('[data-value-render]');
                renderInput.hide();
                $inp.show();
                let value = parseInt($inp.val().replace(/\ /g,''));
                $inp.val(value);
            });
            input.addEventListener('blur', function () {
                let $inp = $(this);
                let renderInput = $inp.parent().find('[data-value-render]');

                renderInput.show();
                $inp.hide();
                el.noUiSlider.setHandle(handle, this.value);
            });
            input.addEventListener('change', function () {
                let value = Math.round(this.value);
                if ( value > maxVal ) {
                    value = maxVal;
                } else if (value < minVal) {
                    value = minVal;
                }
                let valueToRender = value.toLocaleString('ru-RU');
                let currentSlider = this.parentElement;
                let renderValue = $(currentSlider).find('[data-value-render]');
                window.requestAnimationFrame(() => {
                    if ( type === 'price' || type === 'firstPayment') {
                        renderValue.html( valueToRender + ' ₽' );
                    } else if ( type === 'years') {
                        renderValue.html(valueToRender + ' ' + declOfNum(value, ['год', 'года', 'лет']) );
                    } else if ( type === 'month') {
                        renderValue.html(valueToRender + ' мес.');
                    }
                });
                el.noUiSlider.setHandle(handle, value);
            });
            input.addEventListener('keyup', function () {
                let value = Math.round(this.value);
                if ( value > maxVal ) {
                    value = maxVal;
                } else if (value < minVal) {
                    value = minVal;
                }
                let valueToRender = value.toLocaleString('ru-RU');
                let currentSlider = this.parentElement;
                let renderValue = $(currentSlider).find('[data-value-render]');
                window.requestAnimationFrame(() => {
                    if ( type === 'price' || type === 'firstPayment') {
                        renderValue.html( valueToRender + ' ₽' );
                    } else if ( type === 'years') {
                        renderValue.html(valueToRender + ' ' + declOfNum(value, ['год', 'года', 'лет']) );
                    } else if ( type === 'month') {
                        renderValue.html(valueToRender + ' мес.');
                    }
                });
            });
        });
    }

    renderInputValue() {

    }
}